// Dashboard / Report Register for an organisation admin (a client's own
// login). Finvise admins always see both pages. A client sees them when its
// organisation has the "dashboard" feature (allowed_features, set on the
// backend) or is listed below. Matched by id or by name, since the same
// company can have a different id on another environment.
const DASHBOARD_ORGANISATIONS = [
	{ id: 37, name: 'Selina Finance Limited' },
	{
		id: 28,
		name: 'Hope Capital Specialist Lending / Hope Capital 2 Limited / Hope Capital 3 Limited / Hope Capital 4 Limited',
	},
]

const normalise = name =>
	String(name || '')
		.replace(/\s+/g, ' ')
		.trim()
		.toLowerCase()

export const hasDashboardAccess = organisation => {
	if (!organisation) return false
	if (
		Array.isArray(organisation.allowed_features) &&
		organisation.allowed_features.includes('dashboard')
	)
		return true
	return DASHBOARD_ORGANISATIONS.some(
		o =>
			(organisation.id != null && String(o.id) === String(organisation.id)) ||
			normalise(o.name) === normalise(organisation.name),
	)
}
